import React, { Component } from 'react';
import "./style.css";
import { connect } from "react-redux";
import { getFromSession } from '../../controller/session';
import Alert from "@material-ui/lab/Alert";
import { Button, ButtonGroup } from '@material-ui/core';
import Snackbar from "@material-ui/core/Snackbar";
import Modal from '@material-ui/core/Modal';
import LoginButton from "../../components/authlogin/authlogin2";
import EqualizerIcon from '@material-ui/icons/Equalizer';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import DataTableWithPaginator from '../../components/tableWithPaginator/tablePaginator';
import { ACTION_ANULATION_FORM, ANULACION_FORM_V2, ANULACION_FORM_NAME_V2, DATA_POR_VALIDAR, EXPORT_DATA_FORM_XLSX, FORM_NAME_ANULATION_FORM, GESTIONA_MODAL_TRY_CATCH, HEADER_TABLE_PAGINATOR_EMPRESAS, HEADER_TABLE_PAGINATOR_EMPRESAS_COM, INIT_CHARGE_CATALOG, OBTENER_DATA_REG_EMPRESAS, OPEN_ANULATION_FORM, OPEN_COMPONENT_INFORMES, PAGINAR_DATA_REG_EMPRESAS, RETURN_HOME_BANDEJA, SEARCH_FORM_FROM_TABLE, TITLE_TABLE_PAGINATOR_EMPRESAS, VALIDATE_USER_TYPE, panelAnulationdForm, CLOSE_MODALES } from './constants';
import SideBar from '../../components/sidebar/sidebar';
import { clearFields, Field, FieldArray, FormSection } from "redux-form";
import { getConsultaPaginada, getDataAnulationForm, getDataRegCompany, getDynamicOptions, getErrorTryCatch, getIdFormulario, getMessageAnulationRya, getOpenAnulationForm, getOpenComponentInformes, getOpenFormBandeja, getOpenMondalTryCatch, getSessionValidated, getSnackBar, getSuc_id, getUserInfo, getUserType } from './selector';
import { ComponetBandeja } from './componetRevision';
import HomeIcon from '@material-ui/icons/Home';
import { encode } from '../../controller/utils';
import { ComponetInformes } from "./componentInformes";
import Customform from '../../components/materialform/customform';
import LoginButtonFirebase from '../../components/authlogin/authloginFirebaseColaborador';

class BandejaComponent extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    // const { validarTipoUser } = this.props;
    // validarTipoUser("authUser");
  }
  componentDidUpdate() {

  }

  showSnackBar(open, message) {
    return (
      <Snackbar open={open} autoHideDuration={2} className="ocultar">
        <Alert severity="success">{message}</Alert>
      </Snackbar>
    );
  }

  modalAnulationForm() {
    const { dataAnulationForm, actionAnulationForm, openAnulationForm, dynamicOptions, messageAnulationRya, closeModales, returnToHome } = this.props;

    return (
      <Dialog
        className="modal-history"
        open
        scroll={'paper'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">ANULAR SOLICITUD</DialogTitle>
        <DialogContent>
          {messageAnulationRya === false ? ""
            :
            <React.Fragment>
              <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                open
              >
                <div className="messageSucess">
                  <React.Fragment>
                    {messageAnulationRya.error ? <Alert className="alert danger">
                      <p>{messageAnulationRya.message}</p>
                    </Alert>
                      :
                      <Alert className="alertsucessBorrador" >
                        <p>{messageAnulationRya.message}</p>
                      </Alert>
                    }
                  </React.Fragment>


                  <div>
                    <ButtonGroup color="primary" aria-label="primary button group">
                      {messageAnulationRya.confirma ?
                        <Button
                          onClick={() => closeModales()}
                        >
                          Cancelar
                        </Button>
                        : ""}
                      <Button
                        onClick={messageAnulationRya.confirma ? () => actionAnulationForm({ type: "anular" }) : messageAnulationRya.home ? () => returnToHome() : () => closeModales()}
                      >
                        Aceptar
                      </Button>
                    </ButtonGroup>
                  </div>


                </div>
              </Modal>

            </React.Fragment>
          }
          <DialogContentText
            id="scroll-dialog-description"
          >
            <div className="component-anulation">
              <Customform
                submitable={false}
                items={panelAnulationdForm()}
                formName={FORM_NAME_ANULATION_FORM}
                handleSubmit={() => actionAnulationForm({ type: "search" })}

                className="formProcessNum"
              />
              {dataAnulationForm ?
                <React.Fragment>
                  <div className="data-anulation-form">
                    <h2>Información afiliacion empleadores </h2>
                    <h3><p>N° Oportunidad: </p>{dataAnulationForm.idOportunidad}</h3>
                    <h3><p>Razon social: </p>{dataAnulationForm.step0.datosinicio.employerNameStart}</h3>
                    <h3><p>N° Identificación: </p>{dataAnulationForm.iduser}</h3>
                    <h3><p>Correo electrónico: </p>{dataAnulationForm.step0.datosinicio.emailCompanyStart}</h3>
                    <h3><p>Estado actual: </p>{dataAnulationForm.stateLabel}</h3>
                  </div>
                  <div className="anulaciones-container">
                    <React.Fragment>
                      <Customform
                        submitable={false}
                        items={ANULACION_FORM_V2}
                        formName={ANULACION_FORM_NAME_V2}
                        className="people-form"
                        dynamicOptions={dynamicOptions}
                      />
                    </React.Fragment>
                  </div>
                </React.Fragment>
                : ""}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGroup color="primary" aria-label="primary button group">
            <Button
              onClick={() => openAnulationForm("closed")}
            >
              Cerrar
            </Button>
            <Button
              onClick={() => actionAnulationForm({ type: "clear" })}
            >
              Limpiar
            </Button>
            {dataAnulationForm ?
              <Button
                onClick={() => actionAnulationForm({ type: "validaAnular" })}
              >
                Anular
              </Button>
              :
              <Button
                onClick={() => actionAnulationForm({ type: "search" })}
              >
                Buscar
              </Button>
            }
          </ButtonGroup>

        </DialogActions>
      </Dialog >
    );

  }

  modalTryCatch(message) {
    const { closeModalTryCatch } = this.props;

    return (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
      >
        <div className="messageSucess">
          <React.Fragment>
            <Alert className="alert danger">
              {message}
            </Alert>
          </React.Fragment>


          <div>
            <Button
              className='buttonFinalizar'
              variant="text"
              color="default"
              onClick={() => closeModalTryCatch()}
            >
              Aceptar
            </Button>
          </div>


        </div>
      </Modal>
    );
  }


  render() {
    const {
      paginarDatosRegEmpresas,
      dataRegCompany,
      openFormBandeja,
      searchFormFromTable,
      validarTipoUser,
      returnToHome,
      consultaPaginada,
      sessionValidated,
      userType,
      exportDataToXlsx,
      userInfo,
      openInformes,
      suc_id,
      openComponentInformes,
      showSnackBar,
      errorTryCatch,
      openMondalTryCatch,
      openAnulationForm,
      openedFormAnulation,
      tipoAuth,
      idFormulario,
    } = this.props;

    const authUser = getFromSession('authUserColaborador');

    if (authUser && authUser.type && !sessionValidated) {
      validarTipoUser(authUser);
    }




    return (
      <React.Fragment>
        {openedFormAnulation ? this.modalAnulationForm() : ""}
        {openMondalTryCatch ? this.modalTryCatch(errorTryCatch) : ""}
        {
          showSnackBar ? this.showSnackBar(
            showSnackBar,
            "Sucess"
          ) : ""
        }
        <h1 className="Encabezado-ra">{userType === "rya" ? "Registro y Aportes" : userType === "comercial" ? "Validación Comercial" : "Validación Ejecutivo Corporativo"}</h1>
        <div className="Content-form">
          <div className="Content-nav">
            {tipoAuth === "auth0" || tipoAuth === null ?
              <LoginButton
                urlRedirect={`${window.location.origin}/bandeja`}
                callbackPath="/bandeja"
              />
              :
              <LoginButtonFirebase
                urlRedirect={`${window.location.origin}/bandeja`}
                callbackPath="/bandeja"
              />
            }

            <div className="button-logout">
              <ButtonGroup color="primary" aria-label="primary button group">
                <Button onClick={() => returnToHome()}>
                  <HomeIcon />
                </Button>

              </ButtonGroup>
            </div>
            {userInfo && userInfo.actionAnular ?
              <div className="button-logout">
                <ButtonGroup color="primary" aria-label="primary button group">
                  <Button onClick={() => openAnulationForm("open")}>
                    Anular solicitud
                  </Button>
                </ButtonGroup>
              </div>
              : ""}
            {userType !== "rya" ?
              <div className="button-logout">
                <ButtonGroup color="primary" aria-label="primary button group">
                  <Button onClick={() => window.open(`${window.location.origin}/empresas?${encode("formulario=comercial" + "&email=" + userInfo.email + "&idUsuaAsesor=" + userInfo.idUser + "&rol=" + userInfo.rol + "&name=" + userInfo.nameCompleted + "&typeId=" + userInfo.tipoId + "&idAsesor=" + userInfo.id + "&phone=" + userInfo.cellPhone)}`)}>
                    Nueva Afiliación
                  </Button>
                </ButtonGroup>
              </div>
              : ""}
            <div className="button-logout">
              <ButtonGroup color="primary" aria-label="primary button group">
                <Button onClick={() => openComponentInformes()} startIcon={<EqualizerIcon />}>
                  Informes
                </Button>

              </ButtonGroup>
            </div>
          </div>
          <div className="Content-body">
            {openInformes ?
              <ComponetInformes /> :
              <React.Fragment>
                {!openFormBandeja ?
                  <div className="p-mt-3">
                    {dataRegCompany && dataRegCompany.length > 0 ?
                      <DataTableWithPaginator
                        data={dataRegCompany}
                        columns={suc_id !== "1" ? HEADER_TABLE_PAGINATOR_EMPRESAS_COM : HEADER_TABLE_PAGINATOR_EMPRESAS} paginarData={paginarDatosRegEmpresas}
                        //seleccionRangoBusqueda={this.state.seleccionRango}
                        searchFormFromTable={searchFormFromTable}
                        tituloTabla={TITLE_TABLE_PAGINATOR_EMPRESAS}
                        modeSelection={"clickFile"}
                        dataPaginada={dataRegCompany} consultaPaginada={consultaPaginada}
                        descargarCSV={exportDataToXlsx} nombreConsulta={"convsPresupuesto"} dataToDownloadCsv={dataRegCompany}
                      //totalConvsFiltradas={dataRegCompany.length}  convsToDownloadCsv={convsToDownloadCsv} 
                      />
                      :
                      <div className="datosPorValidar">
                        <p>{DATA_POR_VALIDAR}</p>
                        <img src="./Recurso-1.png"></img>
                      </div>
                    }
                  </div>
                  :
                  <ComponetBandeja key={idFormulario} />
                }
              </React.Fragment>
            }



            {/* <Dashboard handleChange={handleChange} tab={cuerrentTab} logoutAction={logoutAction} /> */}

          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    dataRegCompany: getDataRegCompany(state),
    openFormBandeja: getOpenFormBandeja(state),
    consultaPaginada: getConsultaPaginada(state),
    sessionValidated: getSessionValidated(state),
    userType: getUserType(state),
    userInfo: getUserInfo(state),
    suc_id: getSuc_id(state),
    openInformes: getOpenComponentInformes(state),
    showSnackBar: getSnackBar(state),
    errorTryCatch: getErrorTryCatch(state),
    openMondalTryCatch: getOpenMondalTryCatch(state),
    openedFormAnulation: getOpenAnulationForm(state),
    dataAnulationForm: getDataAnulationForm(state),
    dynamicOptions: getDynamicOptions(state),
    messageAnulationRya: getMessageAnulationRya(state),
    idFormulario: getIdFormulario(state),
  };
};

const mapDispachToProps = dispatch => {
  return {
    paginarDatosRegEmpresas: (value) => dispatch({ type: PAGINAR_DATA_REG_EMPRESAS, value }),
    obtenerDataRegEmpresas: (value) => dispatch({ type: OBTENER_DATA_REG_EMPRESAS, value }),
    searchFormFromTable: (value) => dispatch({ type: SEARCH_FORM_FROM_TABLE, value }),
    validarTipoUser: (value) => dispatch({ type: VALIDATE_USER_TYPE, value }),
    returnToHome: (value) => dispatch({ type: RETURN_HOME_BANDEJA, value }),
    exportDataToXlsx: (value) => dispatch({ type: EXPORT_DATA_FORM_XLSX, value }),
    openComponentInformes: (value) => dispatch({ type: OPEN_COMPONENT_INFORMES, value }),
    initChargerCatalog: (value) => dispatch({ type: INIT_CHARGE_CATALOG, value }),
    closeModalTryCatch: (value) => dispatch({ type: GESTIONA_MODAL_TRY_CATCH, value }),
    openAnulationForm: (value) => dispatch({ type: OPEN_ANULATION_FORM, value }),
    actionAnulationForm: (value) => dispatch({ type: ACTION_ANULATION_FORM, value }),
    closeModales: (value) => dispatch({ type: CLOSE_MODALES, value }),
  };
};

export default connect(
  mapStateToProps,
  mapDispachToProps
)(BandejaComponent);